// src/components/icon/icon.styles.ts
import { css } from "lit";
var icon_styles_default = css`
  :host {
    display: inline-block;
    width: 1em;
    height: 1em;
    box-sizing: content-box !important;
  }

  svg {
    display: block;
    height: 100%;
    width: 100%;
  }
`;

export {
  icon_styles_default
};
